import { Paper, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getToken, requestErrorHandler } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";

const server = EnvSettings.server;

export default function TagNameSearchAutocomplete({ onChange, style, reset }) {
  const dispatch = useDispatch();
  const [tagList, setTagList] = useState([]);
  const [loadingUsersList, setLoadingUsersList] = useState(false);
  const abortcontroller = useRef();
  const getTagNames = (ser_val) => {
    if (!ser_val && ser_val !== "") {
      return;
    }
    if (abortcontroller.current) {
      abortcontroller.current.abort();
    }

    // Create a new abortcontroller for the new request
    abortcontroller.current = new AbortController();
    setLoadingUsersList(true);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        search_value: ser_val,
      }),
    };
    fetch(server + "/get_stock_item_group_names", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setTagList(result.stock);
        }
        setLoadingUsersList(false);
      })
      .catch((error) => {
        if (error?.name === "AbortError") {
          return;
        }
        console.log(error);
        setLoadingUsersList(false);
      });
  };
  return (
    <Grid item xs={12} style={style || {}}>
      <Autocomplete
        id="tags"
        options={[...tagList]}
        fullWidth
        key={reset || "sdfadsfsda"}
        onChangeCapture={(e, v) => {
          getTagNames(e.target.value);
        }}
        getOptionSelected={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name ?? ""}
        renderInput={(params) => (
          <TextField {...params} label={"Tags"} variant="outlined" />
        )}
        PaperComponent={(props) => (
          <Paper style={{ border: "2px solid #3d57a5" }} {...props} />
        )}
        filterOptions={(options, params) => {
          if (!options.length && params.inputValue) {
            return [{ name: params.inputValue }];
          }
          return options;
        }}
        loading={loadingUsersList}
        onChange={onChange}
        freeSolo={true}
        renderOption={(option, { selected }) => (
          <>
            {option && option.name ? (
              <Grid container>
                <Grid item xs={12}>
                  <Typography style={{ fontSize: 13 }}>
                    {option.name}
                  </Typography>
                </Grid>
              </Grid>
            ) : null}
          </>
        )}
      />
    </Grid>
  );
}
